export const MOCK_DATA: boolean = import.meta.env.VITE_MOCK_DATA === 'true'

export const LIMIT_PER_PAGE = 10

export const CARD_SIZE = 256
export const NEWS_CARD_SIZE = 326

export const getNumberOfCards = (screenSize?: number, cardSize?: number) => {
  const screenSizeOutput = screenSize || screen?.availWidth || innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  const GAP = 16
  const PERCENTAGE_WITHOUT_MARGIN = 0.8
  const CARD_PLUS_GAP = (cardSize || CARD_SIZE) + GAP

  return Math.floor(screenSizeOutput * PERCENTAGE_WITHOUT_MARGIN / CARD_PLUS_GAP)
}

export const numberOfCards: number = getNumberOfCards()
